<template>
  <div class="__button" :class="{ square: !round, short: short, inline: inline }">
    <q-btn
      :class="{ margin: margin, 'full-width': fullWidth }"
      :type="type"
      :color="colorNameFormatter(color)"
      :text-color="textColor"
      :label="label"
      :flat="flat"
      :outline="outline"
      :round="round"
      :dense="dense"
      :icon="icon"
      :icon-right="iconRight"
      :size="size"
      :disable="disable"
      :loading="loading"
      unelevated
      no-caps
      v-close-popup="vClosePopup"
      @click="$emit('click')"
    >
      <q-tooltip ref="tooltip" :delay="tooltipDelay" v-if="tooltip">{{ tooltip }}</q-tooltip>
      <slot />
    </q-btn>
  </div>
</template>

<script>
import { colorNameFormatter } from '@/components/uikit/lib';

export default {
  name: 'CButton',
  props: {
    type: {
      type: String,
      default: 'button',
      validator(value) {
        return ['button', 'a', 'submit', 'reset'].indexOf(value) !== -1;
      },
    },
    label: [String, Number],
    color: { type: String, default: 'standard' },
    // textColor: { type: String, default: 'black' },
    flat: Boolean,
    outline: Boolean,
    round: Boolean,
    icon: String,
    iconRight: String,
    margin: Boolean,
    disable: Boolean,
    loading: Boolean,
    dense: Boolean,
    size: String,
    short: Boolean, // min-width 80px -> 56px
    inline: Boolean,
    fullWidth: Boolean,
    vClosePopup: Boolean,
    tooltip: [String, Number],
    tooltipPosition: String,
    tooltipDelay: {
      type: Number,
      default: 10,
    },
  },
  watch: {
    loading(val) {
      if (this.tooltip && this.$refs['tooltip']) {
        if (val) this.$refs['tooltip'].show();
        else this.$refs['tooltip'].hide();
      }
    },
  },
  computed: {
    textColor() {
      switch (this.color) {
        case 'standard':
          return 'black';
      }
    },
  },
  methods: {
    colorNameFormatter(type) {
      return colorNameFormatter(type);
    },
  },
};
</script>

<style lang="scss" scoped>
.q-btn ::v-deep {
  line-height: $line-height;
}

.q-btn__wrapper ::v-deep {
  padding: $padding-xs $padding-md;
}

.q-btn.q-btn--round ::v-deep {
  min-width: 0;
}

.__button {
  &.square {
    .q-btn ::v-deep {
      min-width: 80px;
    }
  }

  &.square.short {
    .q-btn ::v-deep {
      min-width: 56px;
    }
  }
}

.q-btn__wrapper ::v-deep {
  padding: $padding-xs $padding-md;
}

.__button {
  &.inline {
    display: inline-block;
  }
}

.margin {
  margin-right: $margin-sm;
}
</style>
